import React, { Fragment } from "react";
import brochure from "../../assets/images/pdf/brochure.pdf";
import { useNavigate } from "react-router-dom";

// import thankYouBanner from "https://www.gphomes.in/static/media/thankyouBanner.88bec5fd0921082d1942.jpg"; 
// import thankYouBannerMobile from "https://www.gphomes.in/static/media/thankYouBannerMobile.3b30124afc3aca2c3806.jpg";

function ThankYouPage() {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1); // navigate to previous page
  };

  const goHome = () => {
    navigate("/"); 
  }
  return (
    <Fragment>
      {/* Top Bar with Logo and Back Button */}
      <div className="thankyou-topbar">
        <button className="back-button" onClick={handleBack}>
          ← Back
        </button>
        <img src="https://www.gphomes.in/static/media/gp-logo-2.8eebfeda67aeef20b0e0.png" alt="Logo" className="thankyou-logo" onClick={goHome}/>
      </div>

      <div
        className="thankyou-container d-md-block d-none"
        style={{
          backgroundImage:
            "url('https://www.gphomes.in/static/media/thankyouBanner.88bec5fd0921082d1942.jpg')",
        }}
      >
        <a
          href={brochure}
          download
          target="_blank"
          rel="noopener noreferrer"
          className="thankyou-button"
        >
          📄 Download Brochure
        </a>
      </div>

      <div
        className="thankyou-container-mobile d-block d-md-none"
        style={{ backgroundImage: "url('https://www.gphomes.in/static/media/thankYouBannerMobile.3b30124afc3aca2c3806.jpg')" }}
      >
        <a
          href={brochure}
          download
          target="_blank"
          rel="noopener noreferrer"
          className="thankyou-button-mobile"
        >
          📄 Download Brochure
        </a>
      </div>
    </Fragment>
  );
}

export default ThankYouPage;
